import { Box, Grid, useMediaQuery } from '@material-ui/core';
import { useTheme, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button } from 'evee-ui-common/components/base';
import useRegion from 'store/modules/app/hooks/useRegion';
import useAuth from 'store/modules/auth/hooks/useAuth';

import BenefitItem from './BenefitItem';
import { getItems } from './benefits';
import styles from './styles';

const CarSharingBenefits = ({ classes }) => {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { region } = useRegion();
  const { onSignUp } = useAuth();

  return (
    <Box margin={1}>
      <Grid container className={classes.itemsContainer} justifyContent="space-between" spacing={2}>
        {getItems(region).map((b, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} style={{ maxWidth: '320px' }}>
            <Box className={classes.itemContainer}>
              <BenefitItem icon={b.icon} title={b.title} description={b.description} />
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Button
            fullWidth={isTabletOrMobile}
            size="large"
            text="Sign up"
            onClick={onSignUp}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

CarSharingBenefits.propTypes = {
  classes: PropTypes.shape({
    itemsContainer: PropTypes.string.isRequired,
    itemContainer: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(CarSharingBenefits);
